// extracted by mini-css-extract-plugin
export default {"ItemCircle":"s_ItemCircle__5apvl","circle":"s_circle__fyqE2","title":"s_title__V-3lH","subcircle-text":"s_subcircle-text__TdMnA"};